import { render, staticRenderFns } from "./couponDetails.vue?vue&type=template&id=0440e300&scoped=true&"
import script from "./couponDetails.vue?vue&type=script&lang=js&"
export * from "./couponDetails.vue?vue&type=script&lang=js&"
import style0 from "./couponDetails.vue?vue&type=style&index=0&id=0440e300&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0440e300",
  null
  
)

export default component.exports